const ENDPOINT_URL = "/api/v1/localization";
import axios from "axios";

export async function getLocalization({ lang }) {
  const response = await axios.get(ENDPOINT_URL, {
    headers: {
      "Accept-Language": lang,
    },
  });
  return response?.data;
}
